import http from '@/utils/http'
import { PATH_SL, PATH_USER_CENTER } from './consts'
import { ModifyDeviceReq } from './types/device'

export const getDeviceInfo = (duid: string) => {
  return http.get(`${PATH_SL}/v2/facade/devices/info?duid=${duid}`)
}

/**
 * 获取用户设备列表
 * @param groupId 群组id，可选，传则过滤，不传则只返回自己管理的设备列表
 * @returns Response
 */
export const getUserDevicesV2 = (groupId?: string) => {
  let url = `${PATH_USER_CENTER}/v2/devices`
  if (groupId) {
    url += `?groupId=${groupId}`
  }
  return http.get(url)
}

/**
 * 获取设备名称信息
 * @param duids 设备id列表 String
 * @param type 22代表下棋机器人
 * @returns Response
 */
export const getDevicesName = (duids: string, type = 22) => {
  return http.get(`${PATH_SL}/v1/wx/device/name?duids=${duids}&type=${type}`)
}

/**
 * 编辑设备信息
 * @param data
 * @returns Response
 */
export const getModifyDevice = (data: ModifyDeviceReq) => {
  return http.post(`${PATH_SL}/v1/wx/device/modify`, data)
}

/**
 * 解绑设备
 * @param deviceId 设备id
 * @param groupId 群组id（主键id）
 * @returns Response
 */
export const unbindDeviceV2 = (deviceId: string, groupId: string) => {
  return http.put(`${PATH_USER_CENTER}/v2/devices/unbind`, {
    deviceId,
    groupId,
  })
}

/**
 * 修改设备通知信号
 * @param duid 设备id
 * @param signal 信号类型：1代表数据回流信号，2代表远程调试信号
 * @param data 具体的信号内容 0代表开关关闭，1代表开关开启
 * @returns
 */
export const changeDeviceSignal = (duid: string, signal: number, data: number) => {
  return http.post(`${PATH_SL}/v1/wx/device/signal`, {
    type: 22,
    signal: signal,
    data: data,
    duid,
  })
}
